import base58 from 'bs58'
import { sha256 as ethersSha256 } from 'ethers'

import { getChecksumAddress } from '@src/utils/address'

// Computes SHA-256 hash of a hex string
function sha256(msg: string): string {
    // Ensure the input is a valid hex string
    const prefixedMsg = `0x${msg}`
    return ethersSha256(prefixedMsg).slice(2) // Compute SHA-256 hash and remove '0x' prefix
}

export class TronConverter {
    // Converts Tron base58 address to hex format (0x-prefixed)
    static toHex(address: string): string {
        const decoded = base58.decode(address)
        return '0x' + Buffer.from(decoded).toString('hex').slice(2, -8)
    }

    // Converts Tron address to EVM-compatible checksum address
    static toChecksumEVM(address: string) {
        return getChecksumAddress(TronConverter.toHex(address))
    }

    // Converts hex address to Tron base58 format
    static fromHex(address: string): string {
        const addr = '41' + address.slice(2)
        const doubleSha256 = sha256(sha256(addr))
        const checkSum = doubleSha256.slice(0, 8)
        const fullAddress = Buffer.from(addr + checkSum, 'hex')
        return base58.encode(new Uint8Array(fullAddress))
    }
}
